/**
 * Viewer access: ActiveStatus (or LoginStatus) = N → logged in but
 * other members' profiles show basic info only. Own profile stays full.
 */

export function pickField(row, names) {
  if (!row || typeof row !== "object") return null;
  for (const name of names) {
    if (row[name] != null && row[name] !== "") return row[name];
  }
  const lowerMap = {};
  for (const key of Object.keys(row)) {
    lowerMap[key.toLowerCase()] = row[key];
  }
  for (const name of names) {
    const v = lowerMap[name.toLowerCase()];
    if (v != null && v !== "") return v;
  }
  return null;
}

export function normalizeFlag(value) {
  if (value == null || value === "") return "";
  return String(value).trim().toUpperCase();
}

/** ActiveStatus / LoginStatus = N → browse-only (basic) for others' profiles. */
export function isActiveStatusRestricted(row) {
  const active = pickField(row, [
    "ActiveStatus",
    "activestatus",
    "active_status",
    "Active_Status",
  ]);
  const login = pickField(row, [
    "LoginStatus",
    "loginstatus",
    "login_status",
  ]);
  const a = normalizeFlag(active);
  const l = normalizeFlag(login);
  if (a === "N") return true;
  if (a === "" && l === "N") return true;
  return false;
}

export function syncViewerAccessFlags(row) {
  if (!row) {
    localStorage.removeItem("viewerActiveStatus");
    localStorage.removeItem("viewerBrowseRestricted");
    return;
  }
  const active = pickField(row, [
    "ActiveStatus",
    "activestatus",
    "active_status",
  ]);
  const login = pickField(row, [
    "LoginStatus",
    "loginstatus",
    "login_status",
  ]);
  const status = normalizeFlag(active) || normalizeFlag(login) || "Y";
  localStorage.setItem("viewerActiveStatus", status);
  localStorage.setItem(
    "viewerBrowseRestricted",
    isActiveStatusRestricted(row) ? "1" : "0",
  );
}

export function getViewerBrowseRestricted() {
  return localStorage.getItem("viewerBrowseRestricted") === "1";
}

export function isViewingOwnProfile(profileId) {
  const viewer = localStorage.getItem("profileID");
  if (!viewer || !profileId) return false;
  return String(viewer) === String(profileId);
}

/** Full detail for others only when viewer is active (not N). */
export function canViewFullProfileDetails(targetProfileId, profileRow) {
  if (profileRow?.IsOwner) return true;
  if (isViewingOwnProfile(targetProfileId)) return true;
  if (!getViewerBrowseRestricted()) return true;
  return false;
}

export const RESTRICTED_BROWSE_NOTICE_EN =
  "Your account is not fully activated. You can use your own profile, but other members are shown with basic information only. Contact admin to activate full access.";
export const RESTRICTED_BROWSE_NOTICE_HI =
  "आपका खाता पूर्ण सक्रिय नहीं है। आप अपनी प्रोफ़ाइल देख सकते हैं, लेकिन दूसरे सदस्यों की केवल बुनियादी जानकारी दिखेगी। पूर्ण एक्सेस के लिए एडमिन से संपर्क करें।";
